import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchPurchaseDetails, fetchPurchases } from '../actions/purchaseAction';


export function usePurchases() {
  const purchases = useSelector((state) => state.inventory.purchases.PURCHASES);
  console.log({purchases});
  return purchases;
}
export function usePurchasesList() {
  const purchases = useSelector((state) => state.inventory.purchases.PURCHASES);
  console.log({purchases});
  return Object.values(purchases);
}

export function useFetchPurchases() {
  const dispatch = useDispatch();

  // Créez une fonction pour déclencher l'action fetchPurchases
  const fetchPurchasesData = () => {
    dispatch(fetchPurchases());
  };

  return fetchPurchasesData;
}

export function useFetchPurchase(id) {
  const dispatch = useDispatch();

  // Créez une fonction pour déclencher l'action fetchPurchases
  const fetchPurchase = () => {
    dispatch(fetchPurchaseDetails(id));
  };

  return fetchPurchase;
}

// import { usePurchases } from './usePurchases';

// function MonComposant() {
//   const purchases = usePurchases();

//   ...
// }